import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent  implements OnInit {


  selectedTypeTabIndex: number = 0;
  selectedTypeTabName = 'attendance-report'
  buttonColorName: any;
  showSetupPopup: boolean = false;
  selectedTrainingTabIndex: number = 0; 
  programs = [];


  constructor(
    public router: Router
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
  }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel.toLowerCase().replace(/\s/g, '');
    this.selectedTypeTabIndex = event?.index;
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/lnd-setup', { operation: operation }]);

  }

  onClickback() {
    this.router.navigate(['/home/hrportal/lnd']);

  }

   
  
 
}


